import { render, staticRenderFns } from "./ConsultarDoctor.vue?vue&type=template&id=2bb3ad4f"
import script from "./ConsultarDoctor.vue?vue&type=script&lang=js"
export * from "./ConsultarDoctor.vue?vue&type=script&lang=js"
import style0 from "./ConsultarDoctor.vue?vue&type=style&index=0&id=2bb3ad4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports